import React from 'react';
import Moment from 'react-moment';
import Logo1x from '../../assets/images/logo.png';
import Logo2x from '../../assets/images/logo@2x.png';

export default class ContractPDFContent extends React.Component {
  constructor(props) {
    super(props);
    this.passData = this.props.passData;
    this.currentDate = new Date();
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  componentDidUpdate = props => {
    this.passData = this.props.passData;
    // console.log(this.passData);
  };

  _renderWages = () => {
    return this.passData.wages.map((wage, index) => {
      const wageAmnt = wage.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円';
      return (
        <tr>
          <td className="subtitle center">{this.passData.titleWages[index]}</td>
          <td>{wageAmnt}</td>
        </tr>
      );
    });
  };

  render = () => {
    return (
      <div className="contract">
        <div className="part1">
          <img src={Logo1x} srcSet={`${Logo1x} 1x,${Logo2x} 2x`} alt="" className="logo" />
          <div className="time p_tb_10 right">
            {' '}
            <Moment tz="Asia/Tokyo" format="YYYY年MM月DD日" style={{ marginRight: '10px' }} />
          </div>
          <div className="title p_tb_10 center">業務委託契約書</div>
          <div className="row">
            <div className="box col-12">
              <div className="b_name">
                <span className="bb">
                  <span className="value">{this.passData.cUserName}</span>
                  <span>殿</span>
                </span>
              </div>
              <div className="row mt-10">
                <div className="col-4" />
                <div className="col-3 right subtitle">事業主の氏名又は名称</div>
                <div className="col-5">{this.passData.bFacilityName}</div>
              </div>
              <div className="row mt-10">
                <div className="col-4" />
                <div className="col-3 right subtitle">所在地</div>
                <div className="col-5">{this.passData.bAddress}</div>
              </div>
              <div className="row mt-10">
                <div className="col-4" />
                <div className="col-3 right subtitle">代表者氏名</div>
                <div className="col-5">{this.passData.bPic} </div>
              </div>
            </div>
            <div className="name-block">
              <h3>次のとおり業務委託契約を締結します。</h3>
            </div>
            <table>
              <tbody>
                <tr>
                  <td className="subtitle center">契約期間</td>
                  <td>{this.passData.workingTime}</td>
                </tr>
                <tr>
                  <td className="subtitle center">実施場所</td>
                  <td>{this.passData.workingPlace}</td>
                </tr>
                <tr>
                  <td className="subtitle center">
                    <p>業務内容</p>
                  </td>
                  <td>{this.passData.workingResponsiblity} </td>
                </tr>
                {/* <tr>
                  <td className="subtitle center">休暇</td>
                  <td> {this.passData.workingRest}</td>
                </tr> */}
                {this._renderWages()}
              </tbody>
            </table>
          </div>
          <div className="div_bottom">
            <div className="row">
              <div className="caution">※　以上のほかは、当社就業規則による。</div>
            </div>
          </div>
          <div className="message">
            <p>
              以上の契約の成立を証するため、本契約書を2通作成し、各自記名押印の上、
              <br />
              甲乙各1通ずつあこれを保有するものとする。
            </p>
          </div>
          <div className="contracted-date">
            <ul>
              <li>令和</li>
              <li>年</li>
              <li>月</li>
              <li>日</li>
            </ul>
          </div>
          <div className="signature-seal">
            <ul>
              <li>
                <h3>甲</h3>
                <h4></h4>
                <h5>印</h5>
              </li>
              <li>
                <h3>乙</h3>
                <h4></h4>
                <h5>印</h5>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };
}
